<template>
    <!-- 开关二次封装
        @author: liuguisheng
        @date: 2019-9-13
    -->
  <preview-form-item v-if="isDisplay && showRule!=='render'"
                     :labelText="labelName"
                     :labelWidth="labelWidth"
                     :labelPosition="labelPosition"
                     :textAlign="labelTextPosition"
                     :formType="formType"
                     :variableName="model"
                     :rules="validatorRule"
                     :paddingLeft="paddingLeft">
    <div class="form-item_input">
      <el-time-picker align="right"
                      arrow-control
                      v-model="currentModel"
                      value-format="HH:mm:ss"
                      :placeholder="placeholder"
                      :readonly="isReadonly"
                      :disabled="isDisabled"
                      :editable="isEditable"
                      :clearable="isClearable"
                      :style="{ width }">
      </el-time-picker>
    </div>
  </preview-form-item>
</template>
<script>
/** 混入方法 ::: 
 *  @mixin mixPreviewItemTemplateChild 预览表单项子级混入
 */
import { mixPreviewItemTemplateChild } from "@/mixins/preview_item/mix_preview_item_template_child.js";


export default {
  mixins: [ mixPreviewItemTemplateChild ],
}

</script>


// WEBPACK FOOTER //
// src/components/preview_item/PreviewItemTimePicker.vue